
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainForm"];

  clearCircleChoice() {
    this.clearChosenCircle()
  }

  submitUserCircleChoice(e) {
      const userCircleForm = e.target.form
      const circleId = e.target.dataset.circleId
      const currentLocation = window.location.href.split("?")[0]
      const currentLocationParams = window.location.search
      const nextLocation = `${currentLocation}${currentLocationParams.length > 0 ? currentLocationParams + "&": "?"}${encodeURIComponent("subscription_create_token[circle_id]")}=${circleId}`
      // NOTE mabye we want to do something different here and have json responses instead of js responses from user_circles_controller#show
      window.history.pushState("", "", nextLocation) // result of remote form success is a window.location.reload() - need correct url params otherwise we will reload current page instead of next page
      railsFire(userCircleForm, "submit") // remote form
  }

  selectCircle(e) {
    this.clearChosenCircle(false)
    const elemTarget = e.target.closest('.choose-circle-wrapper')
    const circleId = elemTarget.dataset.value
    const circleData = document.querySelector(elemTarget.dataset.target)
    document.querySelectorAll(".choose-circle-wrapper").forEach( el => {
      const elemInput = el.querySelector("input[type='radio']")
      if (elemInput.value == circleId) {
        elemInput.checked = true
      } else {
        elemInput.checked = false
      }
    })
    document.querySelectorAll(".circle-data-container").forEach( el => el.classList.add("d-none") )
    if (circleData) { 
      circleData.classList.remove("d-none")
      this.mainFormTarget.classList.add("d-none")
     } else {
      this.mainFormTarget.classList.remove("d-none")

       // TODO update continue button text if waiting list
       // TODO add accept_waiting_list if dataset waiting list is set to true
       this.mainFormTarget.insertAdjacentHTML("beforeend", `<input type="hidden" name="subscription_create_token[circle_id]" value="${circleId}">`)
     }
  }
  
  clearChosenCircle(submit = true) {
    const circleChoices = this.mainFormTarget.querySelectorAll('input[name="subscription_create_token[circle_id]"]');
    const waitingListChoices = this.mainFormTarget.querySelectorAll('input[name="subscription_create_token[accept_waiting_list]"]');
    const forcedChoices = this.mainFormTarget.querySelectorAll('input[name="force"]');
    if (circleChoices) { circleChoices.forEach((choice => choice.remove())); }
    if (waitingListChoices) { waitingListChoices.forEach((choice => choice.remove())); }
    if (forcedChoices) { forcedChoices.forEach((choice => choice.remove())); }
    if (submit) { this.mainFormTarget.submit(); }
  }
}